import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import fetch from 'cross-fetch';

const NEXT_PUBLIC_ZAPIER_ORIGIN = process.env.NEXT_PUBLIC_ZAPIER_ORIGIN;
if (!NEXT_PUBLIC_ZAPIER_ORIGIN) {
  throw new Error('NEXT_PUBLIC_ZAPIER_ORIGIN not set');
}

export const ZAPIER_GRAPHQL_URL = `${NEXT_PUBLIC_ZAPIER_ORIGIN}/api/graphql/v2`;

const ZapierLink = new HttpLink({
  uri: ZAPIER_GRAPHQL_URL,
  credentials: 'include',
  fetch,
});

export const ZapierClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ZapierLink,
  name: 'pagebuilder'
});
